export const parseAddress = (address?: string): string => {
  if (!address) {
    return '';
  }

  const trimmedAddress = address.trim();
  const commaIndex = trimmedAddress.indexOf(',');

  if (commaIndex === -1) {
    return trimmedAddress;
  }

  return trimmedAddress.substring(0, commaIndex).trim();
};
